import containers from './containers'
import forms from './forms'
import type { App } from 'vue'

const components = {
    ...containers,
    ...forms,
}

const install = (app: App) => {
    Object.keys(components).forEach((componentName) => {
        app.component(componentName, components[componentName as keyof typeof components])
    })
}

export default install
